import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import Swipe from 'react-easy-swipe';
import ReactGA from 'react-ga';

import routes from 'config/routes.js';
import {PERIOD_TYPES_ARR} from 'config/constants/period';

import PeriodDropdownRoute from 'router-with/period/PeriodDropdownRoute';

import NotificationAlertsContainer from 'containers/notifications/NotificationAlertsContainer';

import Sidebar from 'components/ui/layout/nav/Sidebar';
import CookieBanner from 'components/notifications/CookieBanner';
import HeaderBar from 'components/ui/layout/nav/HeaderBar';
import SubnavigationRoute from 'router-with/ui/layout/nav/SubnavigationRoute';
import LoadingIndicator from 'components/ui/loading/LoadingIndicator';
import SpogModal from 'components/ui/layout/panel/SpogModal';
import CheckVersion from 'components/check-version/CheckVersion';

import { collapseSidebar, expandSidebar, refreshResize } from 'modules/ui';
import { logout } from 'modules/auth';
import {acceptNewFeatures} from 'modules/newFeatures';
import {newFeaturesConfig} from 'config/newFeatures';

import {debounce, isMobile, getMatchRoute} from 'util/utils';
import {RESIZE_TIMEOUT, INIT_INDEX} from 'util/constants';
import {GOOGLE_ANALYTICS_ID} from 'config';

import 'style/routes/app-layout.scss';
import {GOOGLE_ANALYTICS_COOKIES} from 'util/cookies';

import {unimpersonateUser, finishProcess} from 'modules/impersonateUser';

/**
 * Redirect to login if there is no login.
 */
const _checkLogin = props => {
    const {dispatch, location: {pathname}, auth} = props;

    const matchRoute = getMatchRoute(routes, pathname);

    if (matchRoute) {
        if (matchRoute.isExternal) {
            if (auth.isLoggedIn && auth.user) {
                dispatch(routerActions.push('/'));
            }
        } else if (!auth.isLoggedIn || !auth.user) {
            dispatch(routerActions.push('/login'));
        }
    } else {
        console.error(`The route '${pathname}' was not found.`);
    }
};

const MAX_TIME_NEW_FEATURES = 4;
const DOCUMENT_DATE = newFeaturesConfig.en[INIT_INDEX].date.toString();

/** Component to draw the Application, it has got the menu and the header */
class AppLayout extends Component {

    static propTypes = {
        ui:              PropTypes.object, // Object with ui state
        auth:            PropTypes.object, // Object with auth state
        newFeatures:     PropTypes.object, // Object with new features
        showUpdateModal: PropTypes.bool, // True when the updated modal should appear
        cookiesManager:  PropTypes.object // The configuration of the cookies
    };

    static defaultProps = {
        showUpdateModal: true
    };

    state = {
        showNewFeaturesModal:           false,
        doNotShowNewFeaturesModalAgain: false
    };
    /**
     * Set this to handlers.
     */
    componentWillMount() {
        const {cookiesManager, newFeatures, auth} = this.props;

        _checkLogin(this.props);


        this.handleToggle = this.handleToggle.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleOnunimpersonate = this.handleOnunimpersonate.bind(this);
        this.handleTransition = this.handleTransition.bind(this);
        this.handleResize = this.createHandleResize();

        if (cookiesManager.googleAnalytics === false) {

            document.cookie = `_gat=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
            document.cookie = `_ga=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
            document.cookie = `_gid=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

            GOOGLE_ANALYTICS_COOKIES.forEach(cookie => {
                document.cookie = `${cookie}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
            });

            window[`ga-disable-${GOOGLE_ANALYTICS_ID}`] = true;

        }


        if (cookiesManager.googleAnalytics === true) {
            ReactGA.initialize(GOOGLE_ANALYTICS_ID);
            ReactGA.pageview('/');
        }

        this.createHandleResize = this.createHandleResize();
        this.handleNewFeatures = this.handleNewFeatures.bind(this);
        this.handleChangeShowNewFeatures = this.handleChangeShowNewFeatures.bind(this);

        const MONTH = 1;
        const DAY = 2;
        const INIT_DAY = 3;
        const DECIMAL = 10;

        const {fileDate} = newFeatures;
        const currentDate = new Date();
        const day = currentDate.getUTCDate();
        const currentMonth = currentDate.getMonth() + MONTH;
        const lastDate = parseInt(DOCUMENT_DATE.substring(DOCUMENT_DATE.length - DAY), DECIMAL);

        if (auth.isLoggedIn && auth.user) {
            const infoDateMonth = parseInt(DOCUMENT_DATE.substring(DOCUMENT_DATE.length - INIT_DAY, DOCUMENT_DATE.length - DAY), DECIMAL);

            const diff = day - lastDate;

            if (DOCUMENT_DATE !== fileDate) {
                if (infoDateMonth === currentMonth) {
                    if (diff < MAX_TIME_NEW_FEATURES) {
                        this.setState({
                            ...this.state,
                            showNewFeaturesModal: true
                        });

                    }
                } else {
                    this.setState({
                        ...this.state,
                        showNewFeaturesModal: true
                    });
                }
            }

        }
    }

    /**
     * Debounce the scroll
     * Set resize event
     * Add class to body
     */
    componentDidMount() {
        const {ui:{sidebarCollapsed}, auth} = this.props;
        const body = document.querySelector('body');
        const html = document.querySelector('html');

        if (auth.isLoggedIn && auth.user) {
            body.classList.add('app-layout');
        } else {
            body.classList.remove('app-layout');
        }

        window.addEventListener('resize', this.handleResize);

        if (sidebarCollapsed) {
            html.classList.remove('disable-scroll');
        } else {
            html.classList.add('disable-scroll');
        }
    }

    /**
     * Remove class to body
     */
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);

        document.querySelector('body').classList.remove('app-layout');
    }

    componentWillReceiveProps(nextProps) {
        const { ui:{sidebarCollapsed, refresh, auth} } = this.props;
        const body = document.querySelector('body');
        const html = document.querySelector('html');


        if (nextProps.auth !== auth) {
            _checkLogin(nextProps);

            if (nextProps.auth.isLoggedIn && nextProps.auth.user) {
                body.classList.add('app-layout');
            } else {
                body.classList.remove('app-layout');
            }
        }

        if (nextProps.ui.sidebarCollapsed !== sidebarCollapsed ||
            nextProps.ui.refresh !== refresh) {

            if (nextProps.ui.sidebarCollapsed) {
                html.classList.remove('disable-scroll');
            } else {
                html.classList.add('disable-scroll');
            }
        }
    }

    /**
     * Redirect to login if there is no login.
     */
    componentWillUpdate(nextProps) {
        const {history} = this.props;
        const {location: {pathname, search}} = history;

        return routes.forEach(route => {
            if (route.redirect) {
                const stripSlashesRoutePath = route && route.path && route.path.replace(/\//g, '');
                const stripSlashesRoutePathName = pathname && pathname.replace(/\//g, '');

                if (stripSlashesRoutePath === stripSlashesRoutePathName) {
                    history.push({
                        pathname: route.redirect,
                        search
                    });
                }
            }

            return null;
        });
    }

    componentDidUpdate(prevProps) {
        const {impersonateUser: {hash, whoami}, auth: {user}, dispatch} = this.props;

        if (hash !== prevProps.impersonateUser.hash) {
            window.location.reload();
        }

        if (whoami && user && whoami.id !== user.id) {
            dispatch(finishProcess());
        }
    }

    /**
     * Dispatch logout.
     */
    handleLogout() {
        const { dispatch } = this.props;

        dispatch(logout());
    }

    static handleUpdate() {
        window.location.reload();
    }

    /**
     * Toggle the sidebar menu
     */
    handleToggle() {
        const { dispatch, ui:{sidebarCollapsed} } = this.props;

        if (sidebarCollapsed) {
            dispatch(expandSidebar());
        } else {
            dispatch(collapseSidebar());
        }
    }

    /**
     * Handle the transition
     */
    handleTransition(e) {
        if (e.currentTarget === e.target) {
            return this.handleResize(e);
        }

        return false;
    }

    handleNewFeatures() {
        const {dispatch} = this.props;
        const {showNewFeaturesModal} = this.state;

        const date = new Date();
        const clickedDay = date.getUTCDate();

        dispatch(acceptNewFeatures(clickedDay, DOCUMENT_DATE));

        this.setState({
            ...this.state,
            showNewFeaturesModal: !showNewFeaturesModal
        });


    }

    handleChangeShowNewFeatures(e, value) {
        this.setState({
            doNotShowNewFeaturesModalAgain: !value
        });
    }

    handleOnunimpersonate(e) {
        const {dispatch} = this.props;

        dispatch(unimpersonateUser());
    }

    /**
     * Handle when screen is resized
     */
    createHandleResize() {
        const {dispatch} = this.props;

        return debounce(() => {
            !isMobile() && dispatch(refreshResize());
        }, RESIZE_TIMEOUT);
    }

    renderHeaderBar() {
        const {ui, impersonateUser, auth } = this.props;

        return <HeaderBar
            title={ui.title}
            pageTitle={ui.pageTitle}
            isImpersonate={!!impersonateUser.hash}
            onLogout={this.handleLogout}
            onUnimpersonate={this.handleOnunimpersonate}
            user={auth.user}
            onToggle={this.handleToggle}
        />;
    }

    renderOverlay() {
        return (
            <Swipe
                onSwipeLeft={this.handleToggle}

            >
                <div
                    className="sidebar-overlay"
                    onClick={this.handleToggle}
                />
            </Swipe>
        );
    }
    renderSidebar() {
        const {auth, ui:{sidebarCollapsed}} = this.props;

        return (
            <div id="sidebar-wrapper">
                <Sidebar
                    onToggle={this.handleToggle}
                    routes={routes}
                    onLogout={this.handleLogout}
                    user={auth.user}
                    opened={!sidebarCollapsed}
                />
            </div>
        );
    }

    renderPeriod() {
        const {location} = this.props;
        const matchRoute = getMatchRoute(routes, location.pathname);

        if (matchRoute.dateRequired) {

            let periodSection = matchRoute.dateRequired;
            let dropdownItems = PERIOD_TYPES_ARR;

            if (typeof matchRoute.dateRequired === 'object') {
                periodSection = matchRoute.dateRequired.section;
                dropdownItems = matchRoute.dateRequired.types;
            }

            return (
                <PeriodDropdownRoute
                    key="period"
                    section={periodSection}
                    dropdownItems={dropdownItems}
                />
            );
        }

        return null;
    }

    renderExtra() {
        const {location} = this.props;
        const matchRoute = getMatchRoute(routes, location.pathname);
        const ret = [];

        matchRoute.dateRequired && ret.push(this.renderPeriod());

        return ret;
    }
    renderSubNavigation() {
        const {location} = this.props;
        const matchRoute = getMatchRoute(routes, location.pathname);

        if (matchRoute && matchRoute.navNodes) {
            return (
                <SubnavigationRoute
                    routes={matchRoute.navNodes}
                    extra={this.renderExtra()}
                />
            );
        }

        return null;
    }

    renderContent() {
        const {children, ui:{reload}} = this.props;

        return (
            <div className="page-content" key={reload}>
                <NotificationAlertsContainer />
                {this.renderHeaderBar()}
                {this.renderSubNavigation()}
                {children}
            </div>
        );
    }

    renderWrapper() {
        return (
            <div id="content-wrapper">
                {this.renderContent()}
            </div>
        );
    }

    renderUpdateModal() {
        const {intl:{formatMessage}, showUpdateModal} = this.props;

        return (
            <SpogModal
                showModal={showUpdateModal}
                title={formatMessage({id: 'updated.title'})}
                acceptText={formatMessage({id: 'updated.ok'})}
                showAccept
                hideClose
                onAccept={AppLayout.handleUpdate}
            >
                {formatMessage({id: 'updated.text'})}
            </SpogModal>
        );
    }

    renderNewFeaturesModal() {
        const {intl:{formatMessage, locale}} = this.props;
        const {showNewFeaturesModal} = this.state;

        const messages = locale === 'es' ? newFeaturesConfig.es[INIT_INDEX].value : newFeaturesConfig.en[INIT_INDEX].value;


        return (
            <SpogModal
                showModal={showNewFeaturesModal}
                title={formatMessage({id: 'updated.title'})}
                acceptText={formatMessage({id: 'update.ok.accept'})}
                showAccept
                hideClose
                acceptConfirm
                onAccept={this.handleNewFeatures}
            >
                <div className={'new-features'}>
                    {formatMessage({id: 'label.newFeatures.message'})}
                </div>
                <ul>
                    <div dangerouslySetInnerHTML={{__html: messages}} />
                </ul>
            </SpogModal>
        );
    }

    renderPage() {
        const {ui:{sidebarCollapsed}, auth, impersonateUser, children} = this.props;

        if (auth.isFetching || impersonateUser.isLoading) {
            return <LoadingIndicator />;
        }

        if (auth.isLoggedIn && auth.user) {
            return (
                <div
                    id="page-wrapper"
                    className={sidebarCollapsed ? '' : 'open'}
                    onTransitionEnd={this.handleTransition}
                >
                    {this.renderOverlay()}
                    {this.renderSidebar()}
                    {this.renderWrapper()}
                </div>
            );
        }

        return children;
    }

    renderMessage() {
        const {intl:{formatMessage}} = this.props;


        return formatMessage({id: 'cookie.message'});
    }

    render() {
        const {intl:{formatMessage}} = this.props;

        return (
            <div>
                {this.renderPage()}
                {this.renderUpdateModal()}
                {this.renderNewFeaturesModal()}
                <CheckVersion />
                <CookieBanner
                    message={this.renderMessage()}
                    acceptMessage={formatMessage({id: 'cookie.accept'})}
                    moreInformation={formatMessage({id: 'cookie.moreInfo'})}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ui:              state.ui,
    auth:            state.auth,
    impersonateUser: state.impersonateUser,
    newFeatures:     state.newFeatures,
    showUpdateModal: state.updateApp.reload,
    cookiesManager:  state.cookiesManager
});

export default withRouter(injectIntl(connect(mapStateToProps)(AppLayout)));



// WEBPACK FOOTER //
// ./src/containers/ui/layout/AppLayout.jsx